import { useEffect, useState } from "react";
import { clockTickMs } from "../constants";

const days = ["zo", "ma", "di", "wo", "do", "vr", "za"];
const months = [
  "jan", "feb", "mrt", "apr", "mei", "jun",
  "jul", "aug", "sep", "okt", "nov", "dec",
];

function readClock() {
  const now = new Date();
  const day = days[now.getDay()];
  return {
    hours: now.getHours().toString().padStart(2, "0"),
    minutes: now.getMinutes().toString().padStart(2, "0"),
    date: `${day[0].toUpperCase()}${day.slice(1)} ${now.getDate()} ${months[now.getMonth()]}`,
  };
}

// Geeft de tijd als { hours, minutes, date } en ververst op de minuutgrens.
//
// Niet met een vast interval: dat begint te tellen op het moment dat de
// pagina laadt, dus laadt hij om 10:30:45 dan verspringt de klok voortaan op
// :45 en staat er tussen 10:31:00 en 10:31:45 nog "10:30". Daarom mikken we
// elke keer op de eerstvolgende hele minuut. Dat corrigeert meteen de drift
// die een interval oploopt op een scherm dat maanden aan blijft staan.
export function useClock() {
  const [time, setTime] = useState(readClock);

  useEffect(() => {
    let timer = null;

    const schedule = () => {
      const now = new Date();
      const sinceTick = (now.getSeconds() * 1000 + now.getMilliseconds()) % clockTickMs;
      timer = setTimeout(() => {
        setTime(readClock());
        schedule();
      }, clockTickMs - sinceTick);
    };

    schedule();
    return () => clearTimeout(timer);
  }, []);

  return time;
}
